import styled from 'styled-components'
import AttentionIcon from 'components/Common/Icons/Attention'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export const Wrapper = styled.div`
  background: rgba(204, 116, 0, 0.08);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px;
  color: var(--color-orange);
`
export const IconWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`

export const Message = styled.div`
  font: var(--typography-12-16-regular);
  margin-left: 8px;
  min-width: 0;
  word-break: break-word;
  flex-shrink: 1;
  flex-grow: 0;
  max-width: fit-content;
`

export const Delimiter = styled.div`
  background: rgba(204, 116, 0, 0.24);
  width: 1px;
  height: 24px;
  margin: 0 16px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin: 0 8px;
  }
`

export const VerifyNow = styled.button`
  appearance: none;
  border: none;
  background: none;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  font: var(--typography-12-16-semibold);
  color: var(--color-orange);
  flex-shrink: 0;
`

const AlertCompanyHasNoOffers = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleAddOffer = () => {
    navigate(`/acc/sell-wine/my-offers/add-offer/wine`)
  }
  return (
    <Wrapper>
      <IconWrapper>
        <AttentionIcon size={16} />
      </IconWrapper>

      <Message>{t('myCompany.hasNoOffersAlert')}</Message>
      <Delimiter />
      <VerifyNow onClick={handleAddOffer}>{t('myCompany.addOffer')}</VerifyNow>
    </Wrapper>
  )
}

export default AlertCompanyHasNoOffers
